import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import Table from "../Table/Table";
import { getAllAuctions, approveAuction, rejectAuction, cleanupAuctionSSE } from "../../../_actions/user_actions";
import { Button, message, Popconfirm } from 'antd';
import moment from 'moment';
import { UPDATE_AUCTION } from "../../../_actions/types";

function ApproveAuctionsPage(props) {
  const dispatch = useDispatch();
  const AuctionsData = props.data.user?.auctions ?? []

  useEffect(() => {
  	dispatch(getAllAuctions())
    let intervalId = setInterval(() => {
      dispatch(getAllAuctions())
    }, 5 * 60 * 1000);

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
    }, 15 * 60 * 1000);

    // Cleanup interval, timeout, and SSE connection on component unmount
    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      cleanupAuctionSSE();
    };
  }, [dispatch])

  const configureTable = {
    onClick: (group) => {

    },
    tableHeadings: [
      'owner', 'description', 'endDate', 'winner', 'bid', 'action', 'approver'
    ],
  }

  const ApproveComponent = (localProps) => {
    const { row } = localProps

    const removeClickHandler = (e, row) => {
      dispatch(rejectAuction({_id: row._id})).then(response => {
          if (response.payload !== null) {
            message.error(response.payload, 10)
          }
          else {
            message.success("Auction Removed")
          }
          dispatch(getAllAuctions())
      })
      e.stopPropagation()
    }

    const approveClick = () => {
    	dispatch(approveAuction({
    		auctionId: row._id,
    	})).then(response => {
	        if (response.payload !== null) {
	          message.error(response.payload, 10)
	        }
	        else {
	          message.success("Auction Approved")
	        }
          dispatch(getAllAuctions())
	    })
    }

    const actionType = () => {
      if (new Date(row.endDate) <= new Date()) {
        return (
          <Button onClick={(e => removeClickHandler(e, row))} type="primary">Resolve</Button>
        )
      }

      else if (row.approved) {
        return (
          <div>
            <Popconfirm onCancel={e => e.stopPropagation()} onConfirm={(e) => removeClickHandler(e, row)} title="Are you sure you want to permanently delete this auction?" okText="Yes" cancelText="No">
              <Button onClick={(e) => e.stopPropagation()} type="danger">Reject</Button>            
            </Popconfirm>
          </div>
        )
      }

      return (
        <div>
          <Button onClick={approveClick} type="primary">Approve</Button>
          <Popconfirm onCancel={e => e.stopPropagation()} onConfirm={(e) => removeClickHandler(e, row)} title="Are you sure you want to permanently delete this auction?" okText="Yes" cancelText="No">
            <Button onClick={(e) => e.stopPropagation()} type="danger">Reject</Button>            
          </Popconfirm>
        </div>
      )
    }

    return (
      <div className='ApproveContainer' onClick={e => e.stopPropagation()}>
        {actionType()}
      </div>
    )
  }

  const updatedAuctionsData = AuctionsData.map((row, index) => {
    let newRow = {...row}
    // Add flash handling first
    newRow.flash = row.flash;
    newRow.className = row.flash ? 'auctionFlash' : '';

    // Existing transformations
    newRow.bid = row.bid.toLocaleString('en', {useGrouping:true})
    newRow.owner = <a href={"/student/users/" + row.owner_id._id}>{row.owner_id.firstName + ' ' + row.owner_id.lastName}</a>
    newRow.winner = row.winner_id && row.winner_id.lastName !== 'nil' && row.winner_id.lastName !== undefined ? 
        <a href={"/student/users/" + row.winner_id._id}>{row.winner_id.firstName + ' ' + row.winner_id.lastName}</a> : ''
    newRow.endDate = moment(row.endDate).format('YYYY-MM-DD HH:mm')
    newRow.action = <ApproveComponent id={index} row={row} />
    if (row.approved) newRow.approved = row.approver

    // Handle flash timeout
    if (row.flash) {
      setTimeout(() => {
        dispatch({
          type: UPDATE_AUCTION,
          payload: { ...row, flash: false }
        });
      }, 1000);
    }

    return newRow
  })
  
  return (
    <div className='body'>
      <div className='innerBody'>
        <h1>Auctions</h1>
        <Table rowData={updatedAuctionsData} tableData={configureTable}/>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    data: state
  };
}

export default withRouter(connect(mapStateToProps)(ApproveAuctionsPage))
